import { GRADES } from 'app/types/grades.types'

export const TEACHER_RESOURCE_SITE_ASSET = 'TEACHER_RESOURCE_SITE' as const
export const FLORIDA = 'FLORIDA' as const
export const BETA_ASSET = 'BETA' as const
export const HIDE_HOME_BUTTON = 'HIDE_HOME_BUTTON' as const
export const HIDE_STUDENT_BACKPACK_MENU = 'HIDE_STUDENT_BACKPACK_MENU' as const

export const HUB_ASSET_BUSINESS_KEY = '3d24a52f-f5ed-4bc6-aca4-de547e57365f'
export const CKLA_TEACHER_RESOURCE_SITE_ASSET_BUSINESS_KEY =
  '7705006f-1c65-43fa-8cac-390077c922d7'

export const SKILLS_2020 = 'SKILLS_2020' as const
export const SKILLS_2021 = 'SKILLS_2021' as const

export const CKLA_HUB_SKILLS_2020_ASSET_KEY =
  'ecbb1a82-5787-4574-85fc-57f5da05c91a'
export const CKLA_HUB_SKILLS_2021_ASSET_KEY =
  'b5e0953d-9e86-4cf4-b7dc-90e6bc1f96a2'

// We use beta asset for all beta amplify products
// this assets is added automatically to all t.accounts
// to hide Activities from T. users we added one more asset
// user needs to have BETA_ASSET_KEY to see this content
export const BETA_ASSET_KEY = 'a3162472-e672-4ee8-bb92-28ee20dae32e'

export const INTERACTIVE_CLASSROOM_NEW_FOR_BTS_22_ASSET_KEY =
  '1a59e3cc-2f32-41b7-a444-5cd84366c672'

export const HUB_ASSET_KEY = '73d64db1-739a-4a05-afa9-fe139e6769eb'

export const FLORIDA_ASSETS = {
  [GRADES.KINDERGARTEN]: '901d3bd2-c155-4a17-aca8-13324a357a19',
  [GRADES.FIRST_GRADE]: '563fb583-592e-4bb4-a6c5-096c96fdb7c7',
  [GRADES.SECOND_GRADE]: 'bb6ffddc-3ad5-4630-bffe-4ae38dc85c93',
  [GRADES.THIRD_GRADE]: '7753427b-c248-45c0-a992-ce118280b5fd',
  [GRADES.FOURTH_GRADE]: '79e1d74a-fa2b-4f98-960f-25925ddc8b51',
  [GRADES.FIFTH_GRADE]: '3a8481aa-c37c-44d6-8dbb-9b4bca7e54ce',
}

export const HIDE_HOME_BUTTON_ASSET_KEY = '7a5a3cf3-ab87-4be6-947c-bc2a3f1533b4'
export const HIDE_STUDENT_BACKPACK_MENU_ASSET_KEY =
  '1ad14d00-fffe-4435-95d6-094360439de7'

export const ASSETS_MAP: Record<string, string> = {
  [CKLA_TEACHER_RESOURCE_SITE_ASSET_BUSINESS_KEY]: TEACHER_RESOURCE_SITE_ASSET,
  [BETA_ASSET_KEY]: BETA_ASSET,
  [FLORIDA_ASSETS[GRADES.FIRST_GRADE]]: FLORIDA,
  [FLORIDA_ASSETS[GRADES.SECOND_GRADE]]: FLORIDA,
  [FLORIDA_ASSETS[GRADES.THIRD_GRADE]]: FLORIDA,
  [FLORIDA_ASSETS[GRADES.FOURTH_GRADE]]: FLORIDA,
  [FLORIDA_ASSETS[GRADES.FIFTH_GRADE]]: FLORIDA,
  [HIDE_HOME_BUTTON_ASSET_KEY]: HIDE_HOME_BUTTON,
  [HIDE_STUDENT_BACKPACK_MENU_ASSET_KEY]: HIDE_STUDENT_BACKPACK_MENU,
}

export const READERS_MAP: Record<string, string> = {
  [CKLA_HUB_SKILLS_2020_ASSET_KEY]: SKILLS_2020,
  [CKLA_HUB_SKILLS_2021_ASSET_KEY]: SKILLS_2021,
}

export enum HUB_PROGRAMS {
  CKLA = 'CKLA',
  CKLA3 = 'CKLA3',
  CAMINOS = 'CAMINOS',
  CAMINOS_3 = 'CAMINOS_3',
  CAMINOS_3_CA = 'CAMINOS_3_CA',
  TEXAS_SLAR = 'TEXAS_SLAR',
  TEXAS_ELAR = 'TEXAS_ELAR',
  TEXAS_IMRA = 'TEXAS_IMRA',
  TEXAS_IMRA_COMMERCIAL = 'TEXAS_IMRA_COMMERCIAL',
  TEXAS_ELAR_2E = 'TEXAS_ELAR_2E',
  TEXAS_SLAR_2E = 'TEXAS_SLAR_2E',
}

export const HUB_PROGRAMS_OVERRIDES = {
  [HUB_PROGRAMS.TEXAS_ELAR]: HUB_PROGRAMS.TEXAS_IMRA_COMMERCIAL,
  [HUB_PROGRAMS.TEXAS_SLAR]: HUB_PROGRAMS.TEXAS_IMRA_COMMERCIAL,
  [HUB_PROGRAMS.TEXAS_IMRA]: HUB_PROGRAMS.TEXAS_IMRA_COMMERCIAL,
}

export const GRADE_ASSETS = {
  [HUB_PROGRAMS.CKLA]: ['CKLA Hub Grade'],
  [HUB_PROGRAMS.CKLA3]: ['CKLA 3 Hub Grade', 'CKLA - CC - G'],
  [HUB_PROGRAMS.CAMINOS]: ['Caminos Hub Grade'],
  [HUB_PROGRAMS.CAMINOS_3]: ['Caminos 3E Hub Grade'],
  [HUB_PROGRAMS.CAMINOS_3_CA]: ['Caminos 3E CA Hub Grade'],
  [HUB_PROGRAMS.TEXAS_ELAR]: ['Texas ELAR Hub Grade'],
  [HUB_PROGRAMS.TEXAS_SLAR]: ['Texas SLAR Hub Grade'],
  [HUB_PROGRAMS.TEXAS_IMRA]: ['Texas NEW Hub Grade'],
  [HUB_PROGRAMS.TEXAS_ELAR_2E]: ['ELAR 2E Hub Grade'],
  [HUB_PROGRAMS.TEXAS_SLAR_2E]: ['SLAR 2E Hub Grade'],
}

export const GRADE_PROGRAMS = {
  [HUB_PROGRAMS.TEXAS_IMRA_COMMERCIAL]: ['Texas Hub K-2 3-5'],
}

export const FREE_ACCESS_PROGRAMS = [HUB_PROGRAMS.CKLA3]

export const GRADE_FULL_NAMES = {
  [GRADES.KINDERGARTEN]: 'Kindergarten',
  [GRADES.FIRST_GRADE]: 'Grade 1',
  [GRADES.SECOND_GRADE]: 'Grade 2',
  [GRADES.THIRD_GRADE]: 'Grade 3',
  [GRADES.FOURTH_GRADE]: 'Grade 4',
  [GRADES.FIFTH_GRADE]: 'Grade 5',
}

export const GRADE_FULL_NAMES_ORDINAL = {
  [GRADES.KINDERGARTEN]: 'Kindergarten',
  [GRADES.FIRST_GRADE]: '1st Grade',
  [GRADES.SECOND_GRADE]: '2nd Grade',
  [GRADES.THIRD_GRADE]: '3rd Grade',
  [GRADES.FOURTH_GRADE]: '4th Grade',
  [GRADES.FIFTH_GRADE]: '5th Grade',
}

export const MIDDLESCHOOL_GRADES = [3, 4, 5]

export const ALL_GRADES = [
  GRADES.KINDERGARTEN,
  GRADES.FIRST_GRADE,
  GRADES.SECOND_GRADE,
  GRADES.THIRD_GRADE,
  GRADES.FOURTH_GRADE,
  GRADES.FIFTH_GRADE,
]

export const TEACHER_ROLES = ['ROLE_TEACHER', 'TEACHER']
export const STUDENT_ROLES = ['ROLE_STUDENT', 'STUDENT']
export const READONLY_ROLE = 'READ_ONLY'
